var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type)?_c('span',[(_vm.type === 1)?_c('phone-return-icon'):(_vm.type === 2)?_c('magnify-icon'):(_vm.type === 3)?_c('email-icon'):(_vm.type === 4)?_c('cake-variant-icon'):_c('calendar-check-icon')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }